import { millisecondsInAMinute } from '../../../constants/global.constants';

export const getISODateStringWithCurrentTimezone = (date: Date): string =>
  new Date(date.getTime() + -date.getTimezoneOffset() * millisecondsInAMinute).toISOString();
